// src/types/pushDevices.ts — Tokens FCM web (PWA push)

export type PushDevicePlatform = 'web';

export interface PushDevice {
  token: string;
  platform: PushDevicePlatform;
  enabled: boolean;
  userAgent?: string;
  lastSeenAt: Date;
  /** Business courants au moment de l’enregistrement (audit / fan-out). */
  businessIds?: string[];
  createdAt?: Date;
  updatedAt?: Date;
}

export const PUSH_DEVICES_SUBCOLLECTION = 'pushDevices';
export const PUSH_DEVICE_ID_STORAGE_KEY = 'nauvatek_push_device_id';
